<div class="assets-deposit">
  <p>
    <strong>{{ 'sp.revamp.monthlyDeposits:title' | translate }}</strong>
  </p>
  <form [formGroup]="depositForm" (ngSubmit)="onSetDeposit()">
    <ng-container *ngIf="showPlaceholder">
      <div class="assets-deposit-placeholder" (click)="onSelectInput()">
        <span>{{ currency }}</span> <span>{{ assetControl?.value | translateNumber: language }}</span>
      </div>
      <button type="button" class="ui-button" (click)="onSelectInput()">{{ 'sp.revamp.savingsPlan.adjustBTN' | translate }}</button>
    </ng-container>

    <ng-container *ngIf="!showPlaceholder">
      <div class="assets-deposit-amount">
        <div class="assets-deposit-label">
          <label for="value">{{ currency }}</label>
        </div>
        <div class="assets-deposit-input">
          <input
            type="number"
            id="value"
            autocomplete="false"
            inputmode="numeric"
            maxlength="9"
            min="0"
            #amountInput
            class="assets-deposit-input"
            formControlName="asset"
          />
        </div>
      </div>
      <div class="ui-button-group reverse">
        <button class="ui-button secondary" (click)="onResetDefault()">
          {{ 'new_strategy.save_mode.cancel' | translate }}
        </button>
        <button type="submit" class="ui-button">{{ 'new_strategy.save_mode.cta' | translate }}</button>
      </div>
    </ng-container>
  </form>
</div>
